import { render, staticRenderFns } from "./ShipmentsInquiryContainer.vue?vue&type=template&id=038b7edc&"
import script from "./ShipmentsInquiryContainer.vue?vue&type=script&lang=js&"
export * from "./ShipmentsInquiryContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports